import { render } from "./UrofibreFibreAdhiesePage.vue?vue&type=template&id=7f175530"
import script from "./UrofibreFibreAdhiesePage.vue?vue&type=script&lang=js"
export * from "./UrofibreFibreAdhiesePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__